import React, { FC, useCallback } from 'react';
import { confirm, Button } from 'src/common';
import { useTranslation } from 'react-i18next';
import styles from '../index.module.scss';
import modalStyles from 'src/common/Modal/index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { useDeleteUser } from 'src/models/admin/hooks';

interface Props {
  email: string;
  companyId?: string;
}

export const DeleteUser: FC<Props> = ({ email, companyId }) => {
  const { t } = useTranslation();

  const [deleteUser, { loading }] = useDeleteUser();

  const onDelete = useCallback(() => {
    confirm.confirm({
      title: t('AdminPage.deleteUserConfirmText'),
      content: t('AdminPage.deleteUserConfirmDescription'),
      okText: t('Common.delete'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      onOk() {
        deleteUser({ email, companyId });
      }
    });
  }, [companyId, deleteUser, email, t]);

  return (
    <div className={styles.action}>
      <Button
        type={'link'}
        onClick={onDelete}
        loading={loading}
        icon={<FontAwesomeIcon icon={faTrash} className={styles.icon} />}
      />
    </div>
  );
};

export default DeleteUser;
